// src/components/admin/DropDowns.tsx
import { useState, useEffect } from 'react';
import {
  getAreasAndNeighborhoodTags,
  getPropertieslist,
} from '@/API/apiService';

export interface Area {
  id: number;
  name: string;
  name_en: string;
}

export interface Tag {
  id: number;
  name: string;
  name_en: string;
}

export const useNeighborhoodList = () => {
  const [areas, setAreas] = useState<Area[]>([]);
  const [tags, setTags] = useState<Tag[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    getAreasAndNeighborhoodTags()
      .then((response) => {
        const data = response.data.data;
        if (data) {
          setAreas(data.areas);
          setTags(data.neighborhood_tags);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Areas and Neighborhood Tags の取得に失敗:', err);
        setError(err);
        setLoading(false);
      });
  }, []);

  return { areas, tags, loading, error };
};

export interface Property {
  area_id: number;
  area_name: string;
  area_name_en: string;
  chillnn_id: string;
  property_id: number;
  property_name: string;
  property_name_en: string;
}

export const usePropertiesList = () => {
  const [properties, setProperties] = useState<Property[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    getPropertieslist()
      .then((response) => {
        // API の返り値は response.data.data がプロパティの配列である前提
        setProperties(response.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('プロパティリストの取得に失敗:', err);
        setError(err);
        setLoading(false);
      });
  }, []);

  return { properties, loading, error };
};
